(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcd-christmas-hub"] && !Shopify.designMode) return;
  try {
    
function initGko(root){if(root.dataset.ready)return;root.dataset.ready='true';const find=s=>root.querySelector(s),cards=[...root.querySelectorAll('[data-gko-card]')],grid=find('[data-gko-grid]'),search=find('[data-gko-search]'),budget=find('[data-gko-budget-select]'),trade=find('[data-gko-trade-select]'),category=find('[data-gko-category]'),sort=find('[data-gko-sort]'),more=find('[data-gko-more]');let limit=12;
function paint(reset=true){if(reset)limit=12;const term=search.value.trim().toLowerCase(),max=Number(budget.value);let matching=cards.filter(c=>(!term||c.dataset.search.includes(term))&&(!max||Number(c.dataset.price)<max)&&(!trade.value||c.dataset.trades.includes(trade.value))&&(!category.value||c.dataset.category===category.value));if(sort.value!=='featured')matching.sort((a,b)=>(Number(a.dataset.price)-Number(b.dataset.price))*(sort.value==='asc'?1:-1));cards.forEach(c=>c.hidden=true);matching.forEach((c,i)=>{grid.append(c);c.hidden=i>=limit});find('[data-gko-count]').textContent=matching.length+' '+find('[data-gko-count-label]').textContent;find('[data-gko-empty]').hidden=matching.length>0;more.hidden=matching.length<=limit;}
[budget,trade,category,sort].forEach(x=>x.addEventListener('change',()=>paint()));search.addEventListener('input',()=>paint());more.addEventListener('click',()=>{limit+=12;paint(false)});find('[data-gko-reset]').addEventListener('click',()=>{search.value='';budget.value='0';trade.value='';category.value='';sort.value='featured';paint()});root.querySelectorAll('[data-gko-budget],[data-gko-trade]').forEach(b=>b.addEventListener('click',()=>{search.value='';category.value='';budget.value=b.dataset.gkoBudget||'0';trade.value=b.dataset.gkoTrade||'';paint();find('#gko-range').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});search.focus({preventScroll:true})}));paint();}
document.querySelectorAll('[data-gko-root]').forEach(initGko);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-gko-root]').forEach(initGko));

  } catch(e) { console.error(e); }
})();
})();
